import { Button } from "@/shared/ui";

import CircleGreenAttentionIcon from '@/assets/icons/circle-green-attention.svg';

interface IProps {
    onOkay?(): void;
};

const NoEmailPopup = ({ onOkay }: IProps) => (
    <div data-testid="set-password-flow-no-email-container" className="flex flex-col items-center">
        <img width={35} src={CircleGreenAttentionIcon} alt="circle checkmark icon" className="w-[2.1875rem] md:w-[3.4375rem] mb-2.5" />
        <h3 data-testid="set-password-flow-no-email-title" className="text-center text-[1.5625rem] md:text-[2.1875rem] font-agrandir font-normal leading-normal mb-4">You must create an Email to Continue</h3>
        <p data-testid="set-password-flow-no-email-subtitle" className="text-center text-17 md:text-xl mb-[1.5625rem] md:mb-7.5 font-dmSans">An email is needed to access your account and stay updated. Please set one up to continue.</p>

        <Button
            className="w-full"
            showEndIcon
            onClick={onOkay}
            testId="button-set-password-flow-no-email-ok"
        >
            <span className="font-dmSans font-bold">Okay, I Understand</span>
        </Button>
    </div>
);

export default NoEmailPopup;